import React, { useEffect } from "react";

const ELFSIGHT_SCRIPT_SRC = "https://elfsightcdn.com/platform.js";

const TestimonialSection: React.FC<{ data?: any }> = ({ data }) => {
  useEffect(() => {
    const existingScript = document.querySelector(
      `script[src="${ELFSIGHT_SCRIPT_SRC}"]`
    );

    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.src = ELFSIGHT_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="py-20 max-w-7xl mx-auto px-4 lg:px-8 font-manrope">
      <div className="text-center mb-12">
        {data?.title ? (
          <h2 
            className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-4 text-[#06213F]"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
        ) : (
          <h2 className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-4">
            <span className="text-[#06213F]">Real Words from Real </span>
            <span className="text-primary-red text-[#c20c15]">People</span>
          </h2>
        )}
      </div>

      <div
        className="elfsight-app-56efeca9-74bb-4164-9af7-f36e2735c3fa"
        data-elfsight-app-lazy
      />
    </div>
  );
};

export default TestimonialSection;
